import { CouvertTranslations } from ".";

export const COVERT_ES_MX: CouvertTranslations = {
	label: "Editar couverts",
	editCouvert: "Editar couvert",
	newCouvert: "Agregar couvert",
	saveChanges: "Guardar cambios",
	createCouvert: "Crear couvert",
	male: "Masculino",
	female: "Femenino",
	mesas: "Mesas",
	active: "Activo",
	disabled: "Inactivo",
	edit: "Editar",
	add: "Agregar",
	cancel: "Cancelar",
	delete: "Eliminar",
	emptyState: {
		title: "Aún no hay nada aquí",
		subtitle: "Cuando agregues un nuevo couvert, aparecerá aquí.",
	},
	deleteModal: {
		title: "¿Deseas eliminar este couvert?",
		firstDescription:
			"Al confirmar, ya no podrás visualizar el couvert y no podrás aplicarlo en operaciones del PDV.",
		secondDescription: "Los registros en el reporte permanecerán en el historial.",
		cancel: "Cancelar",
		confirm: "Eliminar couvert",
	},
	columns: {
		public: "Público",
		name: "Nombre",
		category: "Categoría",
		price: "Precio",
		fiscalProfile: "Perfil fiscal",
		fiscalProductGroup: "Grupo fiscal",
	},
	placeholders: {
		name: "Define el nombre de tu Couvert",
		public: "Selecciona el público",
		category: "Selecciona la categoría",
	},
	alert: {
		title:
			"Al habilitar el modo fiscal, los couverts fueron deshabilitados, actualiza los datos fiscales de los couverts para habilitarlos nuevamente.",
		message:
			"Los datos fiscales de couvert son obligatorios para la emisión fiscal. Si aún no tienes datos fiscales de couvert, agrégalos ",
		action: "haciendo clic aquí",
	},
	error: {
		value: {
			required: "Este campo es obligatorio",
			value: "El valor del couvert debe ser menor o igual al límite de postpago",
		},
		name: {
			required: "El nombre es obligatorio",
			maxLength: "El nombre solo puede tener hasta {{maxLength}} caracteres",
		},
		category: {
			required: "La categoría es obligatoria",
			maxLength: "La categoría solo puede tener hasta {{maxLength}} caracteres",
		},
		kind: {
			required: "Público es obligatorio",
		},
	},
};
